import { useEffect, useState } from 'react';
import type { UiWikiPage } from '@nightshift/ui-types';
import { api } from '../live/api.ts';

// Images the documentation links to are bundled as hashed /assets/ URLs, keyed by repository path.
const images = import.meta.glob<string>('../../../docs/**/*.{png,jpg,jpeg,gif,svg,webp}', {
  query: '?url', import: 'default', eager: true,
});
const assets: Readonly<Record<string, string>> = Object.fromEntries(
  Object.entries(images).map(([path, url]) => [path.slice(9), url]),
);

/** The Help views share one asynchronous database-backed content boundary. */
export function useHelpContent(): {
  pages: readonly UiWikiPage[];
  assets: Readonly<Record<string, string>>;
  loading: boolean;
  error: string | null;
} {
  const [state, setState] = useState<{
    pages: UiWikiPage[]; loading: boolean; error: string | null;
  }>({ pages: [], loading: true, error: null });
  useEffect(() => {
    let cancelled = false;
    void api.help().then(({ pages }) => {
      if (!cancelled) setState({ pages, loading: false, error: null });
    }).catch((error: unknown) => {
      if (!cancelled) setState({ pages: [], loading: false, error: error instanceof Error ? error.message : 'Unable to load Help' });
    });
    return () => { cancelled = true; };
  }, []);
  return { ...state, assets };
}
